import { TelerikReportViewer } from "@progress/telerik-react-report-viewer";
import { urlTelerik } from "../../services/http-common";
import themeBase from "../../utils/theme/themeBase";
import { useEffect, useRef } from "react";
import TokenService from "../../services/tokenService";
import { keyAccess } from "../../utils/helpers/helpers";
import AuthService from "../../services/authService";

export enum ETelerikViewmode {
  INTERACTIVE = "INTERACTIVE",
  PRINT_PREVIEW = "PRINT_PREVIEW",
}

function BaseTelelirk({
  reportName = "",
  parametros = {},
  viewMode = ETelerikViewmode.INTERACTIVE,
}) {
  const urlTelerikR = `${urlTelerik}/reports`;
  const viewerRef = useRef();

  useEffect(() => {
    var { viewerObject } =
      viewerRef.current != null ? viewerRef.current : viewerObject;
    viewerObject.authenticationToken(TokenService.getToken());
    viewerObject.reportSource({
      report: reportName,
      parameters: parametros,
    });
  }, [reportName, parametros]);

  useEffect(() => {
    fetch(`${urlTelerikR}/version`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TokenService.getToken()}`,
      },
    })
      .then((response) => {
        //alert("Error telerick ...");
        //console.log("Código de estado:", response.status);
        if (response.status === 401 || response.status === 403) {
          localStorage.removeItem(keyAccess);
          AuthService.removeToken();
          window.location.assign("/login");
        }
        if (response.ok) {
          response.json().then((data) => {
            console.log("Datos de la respuesta:", data);
          });
        } else {
          console.error("Error al realizar la solicitud:", response.statusText);
        }
      })
      .catch((error) => {
        console.error("Error de red:", error);
      });
  }, []);

  return (
    <>
      <TelerikReportViewer
        ref={viewerRef}
        serviceUrl={urlTelerikR}
        reportSource={{
          report: reportName,
          parameters: parametros,
          // parameters: { editors: { multiSelect: { parametros } } },
        }}
        viewerContainerStyle={themeBase.telerikStyle}
        parametersAreaVisible={true}
        viewMode={viewMode}
        scaleMode="FIT_PAGE_WIDTH"
        scale={1.0}
        enableAccessibility={false}
      />
    </>
  );
}

export default BaseTelelirk;
